import { CarouselItem } from '../../../models/item';
import { html } from 'lit-html';
import { ReviewStarIcons } from './review_star_icon';

/**
 * レビューエリアを返却します
 * @param carouselItem カルーセル-商品情報
 */
export const ReviewArea = (carouselItem: CarouselItem) => {
  const hasNoUserReview = carouselItem.displayUserReview === 0;
  return html`
    <div class="m-simpleitemcard_rate">
      <div class="m-stariconGroup">
        <div class="m-stariconGroup_inner">
          <span
            title="5つ星のうち${carouselItem.displayUserReview}"
            class="m-stariconGroup_rate -size16"
          >
            ${hasNoUserReview ? '' : ReviewStarIcons(carouselItem.displayUserReview)}
          </span>
          ${ReviewLink(carouselItem, hasNoUserReview)}
        </div>
      </div>
    </div>
  `;
};

/**
 * レビューリンクなしのレビューエリアを返却します（バリエーション画面のみ）
 * @param carouselItem カルーセル-商品情報
 */
export const ReviewAreaWithoutReviewLink = (carouselItem: CarouselItem) => {
  const hasNoUserReview = carouselItem.displayUserReview === 0;
  return html`
    <div class="m-itemcard_rate">
      <div class="m-stariconGroup -wrap">
        <div class="m-stariconGroup_inner">
          <span
            title="5つ星のうち${carouselItem.displayUserReview}"
            class="m-stariconGroup_rate -size16"
          >
            ${hasNoUserReview ? '' : ReviewStarIcons(carouselItem.displayUserReview)}
          </span>
        </div>
      </div>
    </div>
  `;
};

/**
 * レビューリンクを返却します
 */
const ReviewLink = (carouselItem: CarouselItem, hasNoUserReview: boolean ) => {
  // レビューはアスクル商品の場合だけ存在する
  const shouldNotDisplay: boolean = carouselItem.isVariation || hasNoUserReview
  return shouldNotDisplay? html`` : html`
    <div class="m-stariconGroup_review">
      <a href="/review/${carouselItem.itemCode}/" class="a-textlink" aria-label="${carouselItem.userReviewCount}件のレビュー">(${carouselItem.userReviewCount})
      </a>
    </div>`
};
